import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Корзина ")
const _hoisted_2 = { class: "flex items-center mt-1" }
const _hoisted_3 = { class: "border border-black/5 rounded-full h-8 mt-1 flex items-center" }
const _hoisted_4 = { class: "w-8 text-center text-sm font-medium" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "w-full h-px bg-black/3 my-4" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Выберите время заказа")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "w-full h-px bg-black/3 my-4" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Итого к оплате")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "w-full h-px bg-black/3 my-4" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Оформить заказ ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Очистить корзину ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiIcon = _resolveComponent("UiIcon")!
  const _component_UiCounter = _resolveComponent("UiCounter")!
  const _component_UiAppbarButton = _resolveComponent("UiAppbarButton")!
  const _component_UiModalPageHeaderClose = _resolveComponent("UiModalPageHeaderClose")!
  const _component_UiModalPageHeader = _resolveComponent("UiModalPageHeader")!
  const _component_UiHeadline = _resolveComponent("UiHeadline")!
  const _component_UiIconBtn = _resolveComponent("UiIconBtn")!
  const _component_UiCaption = _resolveComponent("UiCaption")!
  const _component_UiCell = _resolveComponent("UiCell")!
  const _component_UiTab = _resolveComponent("UiTab")!
  const _component_UiHorizontalScroll = _resolveComponent("UiHorizontalScroll")!
  const _component_UiTitle = _resolveComponent("UiTitle")!
  const _component_UiBtn = _resolveComponent("UiBtn")!
  const _component_UiModalPage = _resolveComponent("UiModalPage")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_UiAppbarButton, _mergeProps(_ctx.$attrs, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal = true))
    }), {
      counter: _withCtx(() => [
        (_ctx.size)
          ? (_openBlock(), _createBlock(_component_UiCounter, {
              key: 0,
              variant: "prominent",
              size: "s"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.size), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_UiIcon, { icon: "ShoppingCart" })
      ]),
      _: 1
    }, 16),
    _createVNode(_component_UiModalPage, {
      modelValue: _ctx.showModal,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showModal) = $event))
    }, {
      header: _withCtx(() => [
        _createVNode(_component_UiModalPageHeader, null, {
          before: _withCtx(() => [
            _createVNode(_component_UiModalPageHeaderClose, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModal = false))
            })
          ]),
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        (_ctx.size)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.cart, (item, key) => {
              return (_openBlock(), _createBlock(_component_UiCell, {
                key: key,
                multiline: ""
              }, {
                right: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.formatCurrency((item.price * item.count) / 100)), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_UiHeadline, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_UiIconBtn, {
                        onClick: ($event: any) => (_ctx.removeFromCart(item)),
                        variant: "tertiary",
                        size: "sm",
                        icon: item.count === 1 ? 'X' : 'Minus'
                      }, null, 8, ["onClick", "icon"]),
                      _createElementVNode("span", _hoisted_4, _toDisplayString(item.count), 1),
                      _createVNode(_component_UiIconBtn, {
                        onClick: ($event: any) => (_ctx.addToCart(item)),
                        variant: "tertiary",
                        size: "sm",
                        icon: "Plus"
                      }, null, 8, ["onClick"])
                    ]),
                    _createVNode(_component_UiCaption, { style: {"margin-left":"16px"} }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.formatCurrency(item.price / 100)) + " x " + _toDisplayString(item.count), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          : (_openBlock(), _createElementBlock("p", _hoisted_5, "Увы, ваша корзина пуста...")),
        _hoisted_6,
        _createVNode(_component_UiHeadline, { weight: "semibold" }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        (_ctx.recess.length)
          ? (_openBlock(), _createBlock(_component_UiHorizontalScroll, { key: 2 }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recess, (recessItem) => {
                  return (_openBlock(), _createBlock(_component_UiTab, {
                    onClick: ($event: any) => (_ctx.selectedRecess = recessItem.id),
                    active: _ctx.selectedRecess === recessItem.id,
                    key: recessItem.id
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(recessItem.begin.slice(0, 5)) + " - " + _toDisplayString(recessItem.end.slice(0, 5)), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick", "active"]))
                }), 128))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _hoisted_8,
        _createVNode(_component_UiHeadline, { weight: "semibold" }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }),
        _createVNode(_component_UiTitle, {
          level: "2",
          weight: "semibold",
          style: {"margin-top":"4px"}
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.formatCurrency(_ctx.sum / 100)), 1)
          ]),
          _: 1
        }),
        _hoisted_10,
        _createVNode(_component_UiBtn, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleCreateRequest.execute())),
          disable: !(_ctx.size && _ctx.selectedRecess !== -1),
          block: "",
          class: "mb-4"
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }, 8, ["disable"]),
        _createVNode(_component_UiBtn, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clearCart())),
          disabled: !_ctx.size,
          variant: "secondary",
          block: ""
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}